import useDashboardContext from 'contexts/dashboard.context';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTE_KEYS } from 'utils/constants';

const NewMealIndex = () => {
  const navigate = useNavigate();
  const { routePrefix } = useDashboardContext();
  useEffect(() => {
    navigate(`${routePrefix}/${ROUTE_KEYS.NEW_MEAL}/${ROUTE_KEYS.NEW_MEAL_BRAND_DETAILS}`, {
      replace: true
    });
  }, []);

  return <div />;
};

export default NewMealIndex;
